import "core-js/modules/es.array.push.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("a-form", {
    attrs: {
      layout: "inline",
      labelAlign: "left"
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("保单号")
    }
  }, [_c("a-input", {
    staticStyle: {
      width: "300px"
    },
    attrs: {
      allowClear: "",
      placeholder: _vm.$t("请输入") + _vm.$t("保单号")
    },
    model: {
      value: _vm.policyNo,
      callback: function ($$v) {
        _vm.policyNo = typeof $$v === "string" ? $$v.trim() : $$v;
      },
      expression: "policyNo"
    }
  })], 1), _c("a-form-item", [_c("a-button", {
    attrs: {
      type: "primary",
      "html-type": "submit"
    },
    on: {
      click: _vm.searchFun
    }
  }, [_vm._v(_vm._s(_vm.$t("查询")))])], 1)], 1), _c("a-table", {
    staticClass: "marginT20",
    attrs: {
      bordered: "",
      columns: _vm.columns,
      "data-source": _vm.data,
      align: "center",
      pagination: _vm.pagination,
      rowKey: "id"
    },
    on: {
      change: _vm.handleStandardTableChange
    },
    scopedSlots: _vm._u([{
      key: "index",
      fn: function (text, record, index) {
        return [_vm._v(" " + _vm._s(index + 1) + " ")];
      }
    }, {
      key: "status",
      fn: function (text) {
        return [_vm._v(" " + _vm._s(text == 1 ? _vm.$t("待生效") : text == 2 ? _vm.$t("保障中") : text == 3 ? _vm.$t("已过期") : text == 4 ? _vm.$t("退保中") : text == 5 ? _vm.$t("已退保") : text == 6 ? _vm.$t("退保失败") : "") + " ")];
      }
    }, {
      key: "action",
      fn: function (text, record) {
        return [record.status != 1 && _vm.isAuth("customer.auditClaimsStore") ? _c("a-button", {
          attrs: {
            type: "primary2",
            size: "small"
          },
          on: {
            click: function ($event) {
              return _vm.$router.push({
                name: "customerAddClaim",
                params: {
                  id: record.policyId,
                  type: 2,
                  auditFlowId: record.auditFlowId
                }
              });
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("申请理赔")))]) : _vm._e()];
      }
    }])
  }, _vm._l(_vm.columns, function (item, i) {
    var _item$slots, _item$slots2, _item$slots3;
    return _c("span", {
      key: i,
      attrs: {
        slot: (_item$slots = item.slots) === null || _item$slots === void 0 ? void 0 : _item$slots.title
      },
      slot: (_item$slots2 = item.slots) === null || _item$slots2 === void 0 ? void 0 : _item$slots2.title
    }, [_vm._v(_vm._s(_vm.$t((_item$slots3 = item.slots) === null || _item$slots3 === void 0 ? void 0 : _item$slots3.title)))]);
  }), 0)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };